import axios, { AxiosResponse } from 'axios';
import {
  IB2CAddressesResponse,
  IB2CAddressWithMetaData,
  IB2CAddress,
  IB2CDeleteAddressResponse,
} from '../../models/b2c/addresses';
import {
  B2C_ADDRESSES_PATH,
  OG_UPDATE_ADDRESS_PROD_URL,
  OG_UPDATE_ADDRESS_QA_URL,
} from '../../constants/links';
import { apiB2C } from '../axios-client';
import { isProd } from '../../utils/environments';
import { getOrderGrooveAddressPayload } from '../../utils/order-groove';
import { withMemberId } from '../utils';

const postOrderGrooveAddressRequest = (
  address: IB2CAddress,
): Promise<AxiosResponse<string>> =>
  axios.post(
    isProd() ? OG_UPDATE_ADDRESS_PROD_URL : OG_UPDATE_ADDRESS_QA_URL,
    getOrderGrooveAddressPayload(address),
    { headers: { 'Content-Type': 'text/plain;charset=UTF-8' } },
  );

const updateOrderGrooveAddress = (addresses: IB2CAddressesResponse) => {
  const newDefaultAddress = addresses?.addresses?.address?.find(
    (address) => address.isDefault,
  );
  if (newDefaultAddress?.isDefault) {
    postOrderGrooveAddressRequest(newDefaultAddress);
  }
};

export const b2cAddressesApi = {
  getDefaultAddress: withMemberId(
    (memberId): Promise<AxiosResponse<IB2CAddressesResponse>> =>
      apiB2C.get(B2C_ADDRESSES_PATH(memberId), {
        params: {
          pageSize: 0,
          pageNumber: 0,
        },
      }),
  ),

  addNewAddress: withMemberId(
    (
      memberId,
      address: IB2CAddress,
    ): Promise<AxiosResponse<IB2CAddressesResponse>> =>
      apiB2C
        .post(B2C_ADDRESSES_PATH(memberId), {
          addresses: {
            address: [address],
          },
        })
        .then((response) => {
          updateOrderGrooveAddress(response.data);

          return response;
        }),
  ),
  deleteAddress: withMemberId(
    (
      memberId,
      { addrIdentifier, lastModifiedDate }: Partial<IB2CAddressWithMetaData>,
    ): Promise<AxiosResponse<IB2CDeleteAddressResponse>> =>
      apiB2C.delete(`${B2C_ADDRESSES_PATH(memberId)}/${addrIdentifier}`, {
        params: {
          lastModifiedDate,
        },
      }),
  ),
  editAddress: withMemberId(
    (
      memberId,
      ...addresses: Array<Partial<IB2CAddress>>
    ): Promise<IB2CAddressesResponse> =>
      apiB2C
        .put(B2C_ADDRESSES_PATH(memberId), {
          addresses: {
            address: addresses,
          },
        })
        .then(({ data }) => {
          updateOrderGrooveAddress(data);

          return data;
        }),
  ),
  getAllAddresses: withMemberId(
    (memberId): Promise<AxiosResponse<IB2CAddressesResponse>> =>
      apiB2C.get(B2C_ADDRESSES_PATH(memberId), {
        params: {
          pageSize: 0,
          pageNumber: 0,
        },
      }),
  ),
};
